import ImageCard from "components/common/Card/ImageCard";
import Carousel from "components/common/Carousel";
import React, { useCallback, useState, useEffect } from "react";
import styles from "./index.module.scss";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { t } from "i18next";
import Label from "components/common/Label";

const getRandomImages = (count, maxId) => {
  // Create an array of image IDs less than maxId
  const imageIds = Array.from({ length: maxId }, (_, i) => i + 1);

  // Shuffle the array
  for (let i = imageIds.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [imageIds[i], imageIds[j]] = [imageIds[j], imageIds[i]];
  }

  // Select the first 'count' images
  return imageIds.slice(0, count);
};

const FacultyPhotos = () => {
  const { dir, language, tenant: tenantDetail } = useAppSelector(getSettings);
  const { lifeChoice } = useLifeChoicePageContext();
  const [images, setImages] = useState([]);

  useEffect(() => {
    // Get 4 random images with IDs less than 18
    const selectedImages = getRandomImages(4, 18);
    setImages(
      selectedImages.map(
        (ele) => `/photo_album_placeholders/photo_album_placeholder_${ele}.jpg`
      )
    );
  }, []);

  const renderItem = useCallback((item) => {
    return <ImageCard src={item} />;
  }, []);

  return (
    <div
      className={`${styles["faculty-photos"]} | container`}
      dir={dir}
      lang={language}
    >
      <Label>{t("facultyPhotos")}</Label>
      <Carousel
        items={
          lifeChoice?.photo_album
            ? lifeChoice?.photo_album
            : tenantDetail.images?.length
            ? tenantDetail.images
            : images
        }
        renderItem={renderItem}
        optionss={{ pagination: true }}
      />
    </div>
  );
};

export default FacultyPhotos;
